import * as React from 'react';
import * as Components from './JRCInputSelect.style';
import { JRCInputSelectExtended } from './JRCInputSelectExtended';
import { JRCInputSelectProps } from './JRCInputSelect.types';
import { JRCModalLayoutProps } from 'components/JRCModal/JRCModalLayout';
import { useWatch, useController } from 'react-hook-form';
import { IconsProp } from './JRCInputSelect.types';
import SelectHierarchicalTreeModal from './SelectHierarchicalTreeModal';
import { PagingResults, jObjectAutocomplete } from 'jamespot-user-api';

export type JRCInputSelectHierarchicalTreeProps = Omit<JRCInputSelectProps, 'asyncPromise'> &
    JRCModalLayoutProps & {
        asyncPromise?: (inputValue: string, page?: number) => Promise<PagingResults<any>>;
        hierarchicalTaxonomyPromise: (uriConcept: string) => Promise<PagingResults<jObjectAutocomplete>>;
        displayModal?: boolean;
        checkboxOptions: Array<{ label: string; value: any }>;
    };

const InputSelectHierarchicalTree = function (
    {
        asyncPromise,
        hierarchicalTaxonomyPromise,
        displayModal = true,
        inPlace = false,
        placeholder,
        control,
        name,
        width,
        ...props
    }: JRCInputSelectHierarchicalTreeProps,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    const selectedOptions = useWatch({ control, name });
    const { field } = useController({ control, name });

    const updateOptions = (options: any) => {
        field.onChange(options);
        setOpen(false);
    };

    const IconButtonBefore: IconsProp['iconBefore'] = {
        color: 'grey2',
        icon: 'icon-search',
        onClick: () => setOpen((openState) => !openState),
    };

    const [isOpen, setOpen] = React.useState(false);

    const asyncPromiseFunction = React.useMemo(
        () =>
            !asyncPromise
                ? undefined
                : (inputValue: string) => {
                      return asyncPromise(inputValue).then((response) => {
                          return response?.data || [];
                      });
                  },
        [asyncPromise],
    );

    return (
        <div ref={ref}>
            <Components.ModalContentInputSelect>
                <JRCInputSelectExtended
                    asyncPromise={asyncPromiseFunction}
                    name={name}
                    control={control}
                    displayOption={true}
                    placeholder={placeholder}
                    iconBefore={displayModal ? IconButtonBefore : undefined}
                    width={width}
                    {...props}
                />
            </Components.ModalContentInputSelect>

            {displayModal && isOpen && (
                <SelectHierarchicalTreeModal
                    inPlace={inPlace}
                    close={() => setOpen(false)}
                    options={selectedOptions}
                    updateOptions={updateOptions}
                    hierarchicalTaxonomyPromise={hierarchicalTaxonomyPromise}
                    limit={props.limit}
                />
            )}
        </div>
    );
};
export const JRCInputSelectHierarchicalTree = React.forwardRef(InputSelectHierarchicalTree);
